<div class="dialog">
  <div class="dialog-header">抄送</div>
  <div class="dialog-body">
    <div class="grid">
      <div class="row validate">
        <div class="column background-page text-right" [style.width]="80 + 'px'">
          <span class="color-danger">*</span> 抄送给
        </div>
        <div class="column" [style.width]="560 + 'px'">
          <nz-cascader [nzOptions]="cascaderOptions" [(ngModel)]="cascaderValue" [nzShowSearch]="true"
            [nzPlaceHolder]="'按类型/标段/单位/部门/岗位/姓名检索并选择'" [nzAllowClear]="true">
          </nz-cascader>
        </div>
      </div>
    </div>
  </div>
  <div class="dialog-footer">
    <button nz-button nzType="default" (click)="cancel()">取消</button>
    <button nz-button nzType="primary" (click)="confirm()" [disabled]="!canConfirm">确认</button>
  </div>
</div>